import { useEffect, useState } from "react";

type LocalStorageOptions<T> = {
    localStorageKey: string;
    defaultValue: T;
};

const useStateWithLocalStorage = <T,>({
    localStorageKey,
    defaultValue,
}: LocalStorageOptions<T>) => {
    const getInitialValue = (): T => {
        try {
            const item = localStorage.getItem(localStorageKey);
            return item ? JSON.parse(item) : defaultValue;
        } catch {
            return defaultValue;
        }
    };

    const [value, setValue] = useState<T>(getInitialValue);

    useEffect(() => {
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(value));
        } catch {
            // Storage may be unavailable (e.g. private browsing); keep state in memory.
        }
    }, [value, localStorageKey]);

    return [value, setValue] as const;
};

export default useStateWithLocalStorage;
